import React from 'react';
import { CheckIcon, SearchIcon } from 'lucide-react';
interface ClueButtonProps {
  name: string;
  viewed: boolean;
  active: boolean;
  onClick: () => void;
  variant?: 'list' | 'hotspot';
  style?: React.CSSProperties;
}
export function ClueButton({
  name,
  viewed,
  active,
  onClick,
  variant = 'list',
  style
}: ClueButtonProps) {
  if (variant === 'hotspot') {
    return <button type="button" onClick={onClick} aria-pressed={active} style={style} className={`absolute hidden min-h-[36px] -translate-x-1/2 -translate-y-1/2 items-center gap-1 whitespace-nowrap rounded-full border-2 px-3 text-sm font-bold transition-colors duration-150 ease-out sm:inline-flex ${active ? 'border-forest bg-forest text-cream' : 'border-forest bg-paper text-forest hover:bg-sand'}`} data-id="element-518" data-mp="3om8rgzh5i3ud">
        {viewed ? <CheckIcon size={14} aria-hidden="true" data-id="element-519" data-mp="bedyoypnj1na" /> : <SearchIcon size={14} aria-hidden="true" data-id="element-520" data-mp="g6xgy8zaakyf" />}
        {name}
        {viewed && <span className="sr-only" data-id="element-521" data-mp="2zxkkbqnzlz3q">(viewed)</span>}
      </button>;
  }
  return <button type="button" onClick={onClick} aria-pressed={active} className={`flex min-h-[52px] w-full items-center justify-between gap-3 rounded-xl border px-4 text-left transition-colors duration-150 ease-out hc-strong ${active ? 'border-teal bg-teal text-cream' : 'border-line bg-paper text-ink hover:bg-sand'}`} data-id="element-522" data-mp="2zvgf95ecqu1v">
      <span className="font-bold" data-id="element-523" data-mp="3imr5rlg614t8">{name}</span>
      <span className={`flex items-center gap-1 text-sm ${active ? 'text-cream' : 'text-ink/80'}`} data-id="element-524" data-mp="3doy1wz2c4mw4">
        {viewed ? <>
            <CheckIcon size={16} aria-hidden="true" data-id="element-525" data-mp="3rp0dk3k1uk2x" /> Viewed
          </> : 'Not viewed'}
      </span>
    </button>;
}